import React, { useMemo } from "react";

import { useLocation } from "react-router";

import AreaType from "@mapmycustomers/shared/types/territory/AreaType";
import { areaTypes } from "@mapmycustomers/shared/util/territory/areaTypes";

import DrawBanner from "./components/DrawBanner";
import SmartBanner from "./components/SmartBanner";

interface Props {
  onCancel?: () => void;
}

const CreationBanner: React.FC<Props> = ({ onCancel }) => {
  const { search } = useLocation();

  const areaType = useMemo(() => {
    if (search) {
      const urlParams = new URLSearchParams(search);
      const areaType = urlParams.get("areaType");
      if (areaType && areaTypes.includes(areaType as AreaType)) {
        return areaType as AreaType;
      }
    }
    return undefined;
  }, [search]);

  return areaType ? (
    <SmartBanner areaType={areaType} newTerritory onCancel={onCancel} />
  ) : (
    <DrawBanner onCancel={onCancel} />
  );
};

export default CreationBanner;
